/**
 * Navigation Constants
 */

export const NAVIGATION_LINKS = [
  { path: '/domains', label: 'Search' },
  { path: '/bundles', label: 'Browse' },
  { path: '/info', label: 'Info' },
  { path: '/services', label: 'Services' },
  { path: '/about', label: 'About' },
  { path: '/faqs', label: 'FAQs' },
  { path: '/contact', label: 'Contact' },
] as const;
